import { render, staticRenderFns } from "./RecuperarSenhaQuestionario.vue?vue&type=template&id=9762e762&scoped=true"
import script from "./RecuperarSenhaQuestionario.vue?vue&type=script&lang=js"
export * from "./RecuperarSenhaQuestionario.vue?vue&type=script&lang=js"
import style0 from "./RecuperarSenhaQuestionario.vue?vue&type=style&index=0&id=9762e762&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9762e762",
  null
  
)

export default component.exports